import { useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import { Box } from "@mui/material";
import { ViewType } from "../view-switcher";
import { PaginationProps } from "~/components/pagination";
import { SpaceSummaryTableList } from "./SpaceSummaryTableList";
import { SpaceSummaryCardList } from "./SpaceSummaryCardList";
import { SpaceSummaryData } from "./useSpaceSummary";

export type SpaceSummaryListProps = {
  views: ViewType[];
  defaultView?: ViewType;
  spaceSummaries: SpaceSummaryData[];
  PaginationProps: Omit<PaginationProps, "setPageItems">;
  className?: string;
};

export function SpaceSummaryList({
  views,
  defaultView = views[0],
  spaceSummaries,
  PaginationProps,
  className,
}: SpaceSummaryListProps) {
  const [searchParams, setSearchParams] = useSearchParams();
  const viewTypeParam = searchParams.get("view");
  const activeView =
    views.find((view) => view === viewTypeParam) || defaultView;

  // Reset pageSize param if viewType changes since each view can have
  // different pageSize choices
  useEffect(() => {
    searchParams.delete("pageSize");
    setSearchParams(searchParams, { replace: true });
  }, [activeView]);

  const cardsList = (
    <SpaceSummaryCardList
      spaceSummaries={spaceSummaries}
      PaginationProps={PaginationProps}
    />
  );

  const tableList = (
    <SpaceSummaryTableList
      spaceSummaries={spaceSummaries}
      PaginationProps={PaginationProps}
    />
  );

  return (
    <Box className={className + " space-summary-list"}>
      {activeView === ViewType.List ? tableList : cardsList}
    </Box>
  );
}
